import React from 'react';

export default function PortalLayoutCampaign({
  campaignName,
  campaignBanner,
  children,
}) {
  return (
    <div className="grid grid-cols-11 gap-6 lg:gap-5">
      <div className="col-span-11 lg:col-span-5">
        <div className="sticky top-0 min-h-min w-full lg:top-5 lg:min-h-[500px]">
          <div className="relative h-full overflow-hidden rounded-xl lg:sticky lg:top-0">
            <img
              className="mx-auto rounded-[40px] object-cover"
              alt={`Banner da Campanha ${campaignName}`}
              src={campaignBanner}
            />
          </div>
        </div>
      </div>
      <div className="relative col-span-11 flex flex-col gap-20 lg:col-span-6">
        {children}
      </div>
    </div>
  );
}
